import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { ACE_URL } from "../../data/catalog";

const tiles = [
  { key: "ace10", span: "md:col-span-7 md:row-span-2", img: "/slabs/ace10.webp", url: ACE_URL, kicker: "Grade 10", title: "Gem Mint", sub: "The grade everyone chases. Flawless centring, corners & surface.", big: true },
  { key: "ace9", span: "md:col-span-5", img: "/slabs/ace9.webp", url: ACE_URL, kicker: "Grade 9", title: "Mint", sub: "Near-perfect slabs at sharper prices." },
  { key: "db", span: "md:col-span-5", img: "/slabs/s_chansey.webp", url: ACE_URL, kicker: "Fresh finds", title: "Newly slabbed", sub: "Fresh graded cards just added to the store." },
  { key: "mid", span: "md:col-span-4", img: "/slabs/ace8.webp", url: ACE_URL, kicker: "Grades 8–7", title: "Collector grades", sub: "Fill the binder gaps." },
  { key: "vintage", span: "md:col-span-8", img: "/slabs/ace6.webp", url: ACE_URL, kicker: "Grades 6–3", title: "Vintage & promos", sub: "Old-school cards with real history in the slab." },
];

const Tile = ({ t }) => (
  <a href={t.url} target="_blank" rel="noopener noreferrer" className={`bento-tile group relative block h-full min-h-[260px] w-full overflow-hidden rounded-[28px] border border-white/10 bg-[#10131B] text-left ${t.big ? "md:min-h-[560px]" : ""}`} data-testid={`bento-${t.key}`}>
    <img src={t.img} alt={t.title} className="absolute inset-0 h-full w-full object-cover opacity-70 transition-transform duration-[1.2s] ease-out group-hover:scale-105" style={{ objectPosition: "center 30%" }} />
    <div className="absolute inset-0 bg-gradient-to-t from-[#07080C] via-[#07080C]/70 to-transparent" />
    <div className="relative flex h-full flex-col justify-end p-6 sm:p-8">
      <span className="font-mono text-xs uppercase tracking-[0.25em] text-volt">{t.kicker}</span>
      <h3 className={`mt-2 font-display font-black uppercase leading-[0.9] ${t.big ? "text-5xl sm:text-7xl" : "text-3xl sm:text-4xl"}`}>{t.title}</h3>
      <p className="mt-3 max-w-sm text-sm text-slate-300">{t.sub}</p>
    </div>
    <span className="absolute right-5 top-5 grid h-11 w-11 place-items-center rounded-full border border-white/20 bg-black/40 backdrop-blur transition-all duration-500 group-hover:rotate-45 group-hover:border-volt group-hover:bg-volt group-hover:text-black">
      <ArrowUpRight className="h-5 w-5" />
    </span>
  </a>
);

export const Bento = () => {
  return (
    <section id="grades" className="mx-auto max-w-[1400px] px-5 py-24 lg:px-10 lg:py-36" data-testid="grades-bento">
      <Reveal className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <SectionLabel n="01">Shop by grade</SectionLabel>
          <h2 className="font-display text-4xl font-black uppercase leading-[0.9] sm:text-6xl">Pick your<br />number.</h2>
        </div>
        <p className="max-w-sm text-base text-slate-300">We don't sell random pulls. Choose the exact ACE-graded slab you want directly from our eBay drop-down menu, from pristine Gem Mint 10s to rare vintage promos. Detailed high-resolution photos of the exact item you will receive, shipped globally with tracked delivery from the UK.</p>
      </Reveal>
      <div className="grid auto-rows-[minmax(260px,auto)] grid-cols-1 gap-5 md:grid-cols-12">
        {tiles.map((t, i) => (
          <Reveal key={t.key} delay={i * 0.07} className={t.span}>
            <Tile t={t} />
          </Reveal>
        ))}
      </div>
    </section>
  );
};
